<template>
  <div>
    <div class="order_detail_main" v-if="detailInfo">
      <div class="order_action">
        <template v-if="detailInfo.state == 'paid'">
          <el-button type="primary" size="mini" @click="handleOrderAudit">
            审核
          </el-button>
        </template>
        <template v-if="detailInfo.state == 'reviewed'">
          <el-button type="primary" size="mini" @click="handleOrderDelivery">
            交付
          </el-button>
        </template>
        <el-button size="mini" @click="handlePrint">打印</el-button>
      </div>
      <section ref="print">
        <div class="info_box label">
          <div class="base_info">
            <div class="tit">
              <el-col :span="18">订单号：{{ detailInfo.orderID }}</el-col>
            </div>
            <el-row>
              <label-item label="客户" :value="detailInfo.creator"></label-item>
              <label-item label="服务周期" :value="billCycleTxt"></label-item>
              <label-item
                label="企业名称"
                :value="detailInfo.customerEnterpriseName"
              ></label-item>
              <label-item
                label="创建时间"
                :value="timetrans(detailInfo.createTime)"
              ></label-item>
              <label-item
                label="支付时间"
                :value="timetrans(detailInfo.payTime)"
              ></label-item>
              <label-item
                label="交易状态"
                :value="handleOrderState(detailInfo.state)"
                :valueStyle="{
                  color: handleOrderState(detailInfo.state, true)
                }"
              ></label-item>
              <label-item
                label="订单金额"
                :value="`${detailInfo.totalPrice}元`"
              ></label-item>
              <label-item
                v-if="detailInfo.note"
                label="订单备注"
                :value="detailInfo.note"
              ></label-item>
            </el-row>
          </div>
        </div>
        <!-- 订单详情 -->
        <div class="detail_info_box" v-if="detailInfo">
          <div class="tit">订单详情</div>
          <div class="detail_table">
            <public-table
              :loading="Loading"
              :column="column"
              :tableData="orderData"
            >
              <template v-slot:comboNamedetail="{ row }">
                <div v-if="row.comboItems && row.comboItems.length > 0">
                  <div
                    v-for="(item, index) in row.comboItems"
                    :key="index"
                    style="display: flex"
                  >
                    <div style="text-align: left; min-width: 70px">
                      {{ item.showName }}&nbsp;:&nbsp;
                    </div>
                    <div style="text-align: left">{{ item.value }}</div>
                  </div>
                </div>
                <div v-else>-</div>
              </template>

              <template v-slot:billCycle="{ row }">
                <div>{{ handleCycle(row.billCycle) }}</div>
              </template>
              <template v-slot:effectTime="{ row }">
                <div>{{ timetrans(row.effectTime) }}</div>
                <div>{{ timetrans(row.expireTime) }}</div>
                <div v-if="row.preOrderID">
                  继承自前序订单
                  <router-link
                    :to="{
                      name: 'storeOrderDetails',
                      params: { orderID: row.preOrderID, marketID: marketID }
                    }"
                    >{{ row.preOrderID }}</router-link
                  >
                </div>
                <div v-if="row.postOrderID">
                  已由后续订单续费
                  <router-link
                    :to="{
                      name: 'storeOrderDetails',
                      params: { orderID: row.postOrderID, marketID: marketID }
                    }"
                    >{{ row.postOrderID }}</router-link
                  >
                </div>
              </template>
            </public-table>
          </div>
        </div>

        <div class="total_box" v-if="detailInfo">
          <div class="item">总价：{{ detailInfo.totalPrice }} 元</div>
          <div class="item">应付：{{ detailInfo.finalPrice }} 元</div>
        </div>

        <!-- 交付详情 -->
        <div class="info_box" v-if="deliveryObj" style="margin-top: 30px">
          <div class="tit">
            交付详情
            <template
              v-if="
                detailInfo.orderApps &&
                detailInfo.orderApps.length > 0 &&
                detailInfo.orderApps[0].redelivery
              "
            >
              <el-button size="mini" @click="handleToDeliver">
                重新交付
              </el-button>
            </template>
          </div>
          <div class="base_info">
            <el-row>
              <label-item label="交付应用名称" :custom="true">
                <template v-slot:value>
                  <router-link
                    v-if="havePerm('Deliver.DeliveryApp.Get')"
                    :to="{
                      name: 'deliverDetails',
                      params: { deliverID: deliveryObj.appID }
                    }"
                    >{{ deliveryObj.appName }}</router-link
                  >
                  <span v-else>{{ deliveryObj.appName }}</span>
                </template>
              </label-item>

              <label-item
                label="交付状态"
                :value="handleAppState(deliveryObj.status)"
                :style="{
                  color: handleAppState(deliveryObj.status, true)
                }"
              ></label-item>
              <label-item label="交付环境" :custom="true">
                <template v-slot:value>
                  <a target="_blank" :href="deliveryObj.regionURL">{{
                    deliveryObj.regionAlias
                  }}</a>
                </template>
              </label-item>

              <label-item label="租户名" :custom="true">
                <template v-slot:value>
                  <a target="_blank" :href="deliveryObj.tenantURL">{{
                    deliveryObj.tenantAlias
                  }}</a>
                </template>
              </label-item>
            </el-row>
          </div>
        </div>
      </section>
    </div>
    <div class="order_detail_main" v-if="noData">
      <no-data />
    </div>
  </div>
</template>
<script>
import { errorHandle } from '@/utils/error';
import { timetrans } from '@/utils/validate';
import { havePerm } from '@/utils/auth';
import { formatDate } from '@/utils/date';
import {
  handleOrderState,
  handleCycle,
  handleAppState
} from '@/utils/dictionary';

export default {
  data() {
    return {
      havePerm,
      timetrans,
      formatDate,
      Loading: true,
      detailInfo: null,
      orderData: [],
      handleCycle,
      handleOrderState,
      handleAppState,
      billCycleTxt: '',
      deliveryObj: null,
      noData: false,
      column: [
        {
          prop: 'appName',
          label: '应用'
        },
        {
          prop: 'appVersion',
          label: '版本'
        },
        {
          prop: 'comboName',
          label: '套餐'
        },
        {
          prop: 'comboNamedetail',
          label: '套餐详情',
          align: 'left',
          scopeStatus: true
        },
        {
          prop: 'billCycle',
          label: '套餐周期',
          width: '100px',
          scopeStatus: true
        },
        {
          prop: 'comboQuantity',
          label: '数量'
        },
        {
          prop: 'effectTime',
          label: '起止时间',
          width: '160px',
          scopeStatus: true
        },
        {
          prop: 'totalPrice',
          label: '金额'
        }
      ]
    };
  },
  created() {
    const params = this.$route.params;
    this.marketID = params.marketID;
    this.orderID = params.orderID;
    this.getDetailInfo();
  },

  methods: {
    getDetailInfo() {
      this.$store
        .dispatch('GetStoreOrderInfo', {
          orderID: this.orderID,
          marketID: this.marketID
        })
        .then((res) => {
          this.Loading = false;
          if (res) {
            this.detailInfo = res;
            if (res.orderApps && res.orderApps.length > 0) {
              this.orderData = res.orderApps;
              this.billCycleTxt =
                this.orderData[0].comboQuantity +
                this.handleCycle(this.orderData[0].billCycle);
              if (this.orderData[0].deliveryAppID) {
                this.getDeliveryDetailInfo();
              }
            }
          }
        })
        .catch((err) => {
          this.Loading = false;
          if (err && err.code == 20001) {
            this.noData = true;
            return null;
          }
          errorHandle(err);
        });
    },
    getDeliveryDetailInfo() {
      this.$store
        .dispatch('GetStoreDeliveryAppInfo', {
          appID: this.orderData[0].deliveryAppID,
          marketID: this.marketID
        })
        .then((res) => {
          this.Loading = false;
          if (res) {
            this.deliveryObj = res;
          }
        })
        .catch((err) => {
          if (err.code != 20001) {
            errorHandle(err);
          }
          this.Loading = false;
        });
    },
    handleToDeliver() {
      this.handleOperation(
        '是否重新交付?',
        'PutStoreToDelivery',
        '操作成功，开始重新交付',
        '重新交付失败'
      );
    },
    // 审核
    handleOrderAudit() {
      this.handleOperation(
        '是否审核该订单?',
        'PutOrderAudit',
        '审核成功',
        '审核失败'
      );
    },
    // 交付
    handleOrderDelivery() {
      this.handleOperation(
        '是否交付?',
        'PutOrderDelivery',
        '操作成功，开始交付',
        '交付失败'
      );
    },
    handlePrint() {
      this.$print(this.$refs.print);
    },
    handleOperation(title, interfaceName, successMessage, errorMessage) {
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store
          .dispatch(interfaceName, {
            marketID: this.marketID,
            orderID: this.orderID
          })
          .then(() => {
            this.$message.success(successMessage);
            this.getDetailInfo();
          })
          .catch(() => {
            this.$message.error(errorMessage);
          });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.mb10 {
  margin-bottom: 10px;
}
.order_action {
  padding: 16px;
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/views/storeManage/orderManage/details/index.vue